import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = { class: "ml-auto mr-2" }
const _hoisted_5 = { class: "bt-icon bt-icon--xs" }
const _hoisted_6 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--primary" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createVNode("h3", _hoisted_2, [
            _createVNode(_component_InlineSvgScoped, { src: _ctx.titleIcon }, null, 8, ["src"]),
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "actionButton", {}, () => [
            (_ctx.showActionButton)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  disabled: _ctx.disabled,
                  onClick: _ctx.onActionButtonClick,
                  class: "p-button-rounded p-button-outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_5, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                        "aria-label": "icon-grid"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("span", _hoisted_6, _toDisplayString(_ctx.actionButtonLabel), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 1
  }))
}